import React, { useEffect, useState } from "react";
import { getAxios } from "../../../Services/commonService";
import { API_USER_EVENT_SHARING } from "../../../../utils/api/ApiConstant";
import SvgIcon from "../../UI/Svg";
import Icon from "../../../../assets/icons/Icon";

const ViewSharingModal = ({ rowData }) => {
  const [viewSharingData, setViewSharingData] = useState([]);

  const fetchSharingData = async (id) => {
    const res = await getAxios(`${API_USER_EVENT_SHARING}/${id}`);
    console.log("🚀 ~ fetchSharingData ~ res:", res);
    setViewSharingData(res);
  };

  useEffect(() => {
    if (!rowData?.id) return;
    fetchSharingData(rowData?.id);
  }, [rowData?.id]);

  // Unique event names for headers
  const eventNames = [
    ...new Set(viewSharingData.map((item) => item.EventTypeName)),
  ];

  // Group data by user
  const usersMap = {};

  viewSharingData.forEach((item) => {
    if (!usersMap[item.UserName]) {
      usersMap[item.UserName] = {
        ...item,
        UserName: item.UserName,
      };
    }

    usersMap[item.UserName][item.EventTypeName] = item.SharedPL;
  });

  const tableData = Object.values(usersMap);
  const hasRecords = tableData.length > 0;

  const columnTotals = viewSharingData.reduce((acc, item) => {
    acc[item.EventTypeName] =
      (acc[item.EventTypeName] || 0) + Number(item.SharedPL || 0);

    return acc;
  }, {});

  return (
    <>
      {!hasRecords ? (
        <div className="not_rows">
          <SvgIcon className="not_icon" name="notData" />
          No rows to show
        </div>
      ) : (
        <>
          <div className="table-responsive">
            <table className="report-card-box" border="1" cellPadding="10">
              <thead>
                <tr>
                  <th rowSpan={2}></th>
                  <th rowSpan={2}>#</th>
                  <th className="text-start" rowSpan={2}>
                    User Name
                  </th>
                  <th colSpan={eventNames?.length}>
                    <b>Game</b>
                  </th>
                </tr>
                <tr>
                  {eventNames.map((event) => (
                    <th className="text-center" key={event}>
                      {event}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {tableData.map((row, index) => {
                  const isLastRow = tableData.length - 1 === index;

                  return (
                    <tr
                      key={row.UserName}
                      className={isLastRow ? "font-weight-bold" : ""}
                    >
                      <td align="center">
                        {isLastRow ? (
                          <b>
                            <Icon name="MoveUp" />
                          </b>
                        ) : (
                          <Icon name="MoveUp" />
                        )}
                      </td>
                      <td align="center">
                        {isLastRow ? <b>{index + 1}</b> : index + 1}
                      </td>
                      <td className="text-start">
                        {isLastRow ? <b>{row.UserName}</b> : row.UserName}
                      </td>

                      {eventNames.map((event) => (
                        <td className="text-center" key={event}>
                          {isLastRow ? (
                            <b>
                              {row[event] !== undefined
                                ? `${row[event]} %`
                                : "-"}
                            </b>
                          ) : row[event] !== undefined ? (
                            `${row[event]} %`
                          ) : (
                            "-"
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={3} align="right">
                    Total:
                  </td>

                  {eventNames.map((event) => (
                    <td key={event} className="text-center">
                      {columnTotals[event] || 0} %
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default ViewSharingModal;
